import * as Types from '../types';

import {gql} from '@apollo/client';
export type PosterOptionsFragment = {
  __typename?: 'Poster';
  options: {
    __typename?: 'PosterOptions';
    activityTypes: Array<Types.ActivityType>;
    colors: Array<any>;
  };
};

export const PosterOptionsFragmentDoc = gql`
  fragment posterOptions on Poster {
    options {
      activityTypes
      colors
    }
  }
`;
